var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"SCHOOL INSIGHTS","title":"Reports and Analytics","description":"Generate report cards, attendance summaries and financial statements.","count-label":"reporting tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }